<template>
  <div class="tab">
    <slot
      name="tab-controls"
      :controlDynamicClasses="controlDynamicClasses"
      :getTabIndex="getTabIndex"
      :isAriaSelected="isAriaSelected"
      :selectTab="selectTab"
      :selectTabWithKey="selectTabWithKey"
    />
    <slot
      name="tab-panels"
      :panelDynamicClasses="panelDynamicClasses"
    />
  </div>
</template>

<script>
  export default {
    name: 'Tab',

    data: () => ({
      tabSelectedId: null,
    }),

    mounted() {
      this.selectInitialTab();
    },

    methods: {
      controlDynamicClasses(id) {
        return {
          'tab-control--active': this.isCurrentSelected(id),
        };
      },

      getTabIndex(id) {
        return this.isCurrentSelected(id) ? '0' : '-1';
      },

      isAriaSelected(id) {
        return this.isCurrentSelected(id).toString();
      },

      isCurrentSelected(id) {
        return id === this.tabSelectedId;
      },

      panelDynamicClasses(id) {
        return {
          'tab-panel--active': this.isCurrentSelected(id),
        };
      },

      selectInitialTab() {
        const allPanels = this.$el.querySelectorAll('.tab-panel');
        if (!allPanels.length > 0) {
          return;
        }

        this.selectTab(allPanels[0].id);
      },

      selectTab(id) {
        const cleanId = id.replace('panel-', '').replace('tab-', '');

        this.tabSelectedId = cleanId;
        this.$el.querySelector(`#tab-${cleanId}`) && this.$el.querySelector(`#tab-${cleanId}`).focus();
      },

      selectTabWithKey({ key }) {
        const allControls = this.$el.querySelectorAll('.tab-control');
        const allControlsIds = Array.from(allControls, (control) => control.id);
        const controlsLength = allControlsIds.length;
        const currentControlIndex = allControlsIds.indexOf(`tab-${this.tabSelectedId}`);

        const validKeys = ['ArrowRight', 'ArrowLeft'];
        if (!validKeys.includes(key)) {
          return;
        }

        if (key === 'ArrowRight') {
          if (currentControlIndex + 1 >= controlsLength) {
            return;
          }

          this.selectTab(allControlsIds[currentControlIndex + 1]);
        }

        if (key === 'ArrowLeft') {
          if (currentControlIndex - 1 < 0) {
            return;
          }

          this.selectTab(allControlsIds[currentControlIndex - 1]);
        }
      },
    }
  };
</script>
